<template>
  <v-card flat>
    <v-card-title>
      <v-text-field
        v-model="search"
        :prepend-icon="searchIcon"
        clearable
        :clear-icon="clearIcon"
        :label="$vuetify.lang.t('$vuetify.shared.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table
        dense
        calculate-widths
        :items-per-page="5"
        :headers="headers"
        :items="tableData"
        :search="search"
      >
        <template v-slot:item.value="{item}">
          {{ item.value }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiClose, mdiDatabaseSearch } from '@mdi/js'
import Vuetify from '@/plugins/vuetify'

export default {
  name: 'tagDataTable',
  props: {
    tableData: Array
  },
  data: () => ({
    search: '',
    searchIcon: mdiDatabaseSearch,
    clearIcon: mdiClose
  }),
  computed: {
    headers: () => ([
      {
        text: Vuetify.framework.lang.t('$vuetify.shared.field'),
        value: 'field'
      },
      {
        text: Vuetify.framework.lang.t('$vuetify.shared.value'),
        value: 'value'
      }
    ])
  }
}
</script>

<style scoped>

</style>
